// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { AccessibilityCheckNameService } from '@client/app/modules/accessibility/services/accessibility-check-name/accessibility-check-name.service';
import { AccessibilityService } from '@client/app/services/entities/accessibility/accessibility.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { ToastService } from '@monsido/angular-shared-components';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { AuditlogService } from '../auditlog.component.service';

@Component({
    selector: 'admin-auditlog-more-info',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header icon="fas fa-random" [header]="'More info' | translate"></page-header>
        </div>
        <div class="mon-dialog-body">
            <div class="card panel-monsido-card mt-4 mx-4">
                <div class="card-body">
                    <table class="table table-hover table-fixed">
                        <thead>
                            <tr>
                                <th class="col-sm-8" translate>Information</th>
                                <th class="col-sm-30" translate>Content</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="action">
                                <td translate>Action</td>
                                <td>{{ action | underscoreless }}</td>
                            </tr>
                            <tr *ngIf="data.page">
                                <td translate>Page</td>
                                <td>
                                    <a [href]="data.page" target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'">{{ data.page }}</a>
                                </td>
                            </tr>
                            <tr *ngIf="data.comment">
                                <td translate>Comment</td>
                                <td>{{ data.comment }}</td>
                            </tr>
                            <tr *ngIf="data.source_code">
                                <td translate>Source code</td>
                                <td>
                                    <pre class="text-wrap">{{ data.source_code }}</pre>
                                </td>
                            </tr>
                            <tr *ngIf="data.check_id">
                                <td translate>Check</td>
                                <td>
                                    <div [innerHTML]="name"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="d-flex" *ngIf="!isAnUndoLog() && canUndo()">
                        <button class="btn btn-border-radius btn-secondary ml-auto"
                                type="button"
                                (click)="undoAccessibilityCheck()"
                                translate>
                            Undo
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class AdminAuditlogMoreInfoComponent implements OnInit {
    @Input() action: string = '';
    @Input() data: any = {};
    @Input() created: boolean = false;
    @Input() target: string = '';
    @Input() sourceCodeId: number = 0;
    @Input() domainId: number = 0;
    @Input() monDialogId?: string;

    name: string = '';

    constructor (
        private accessibilityCheckNameService: AccessibilityCheckNameService,
        private accessibilityService: AccessibilityService,
        private monModalService: MonModalService,
        private toastService: ToastService,
        private translateService: TranslateService,
        private auditlogService: AuditlogService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.name = '';
        if (this.data.check_id) {
            this.accessibilityCheckNameService.getName(this.data.check_id)
                .then((name: string | null) => {
                    if (name == null) {
                        return;
                    }
                    this.name = name;
                })
                .catch(() => {
                    // Handle error silently like in original
                });
        }
    }

    undoAccessibilityCheck (): void {
        const msg = '<div class=\'text-line\'>' + this.translateService.getString('Add comment (Optional)');
        this.monModalService.prompt(msg, {}).then((comment: string) => {
            const params = {
                comment: comment,
                ignored_reviewed: false,
            };

            this.accessibilityService
                .undoAccessibilityCheck(this.domainId, this.sourceCodeId, this.data.check_id, params)
                .then(() => {
                    this.toastService.success(this.translateService.getString('Snippet reset'));
                    // Close dialog if monDialogId is provided
                    if (this.monDialogId) {
                        // TODO: Implement dialog close functionality
                    }
                });
        }).catch(() => {
            // Handle error silently like in original
        });
    }

    isAnUndoLog (): boolean {
        return this.auditlogService.isAnUndoLog(this.action);
    }

    canUndo (): boolean {
        return this.auditlogService.canUndo(this.target);
    }
}
